import getApiReducer from '../../../../common/utils/getApiReducer';
import Immutable from 'immutable';
import { combineReducers } from 'redux';

import { GET_FAVORITES } from './actions';

import {
  FAVORITE_LIBRARY_VIDEO,
  UNFAVORITE_LIBRARY_VIDEO,
  FAVORITE_EPISODE_VIDEO,
  UNFAVORITE_EPISODE_VIDEO,
} from './actions';

const favoritesApiReducer = getApiReducer(GET_FAVORITES);
const favorites = (state, action) => {
  let nextState = favoritesApiReducer(state, action);

  if (action.type === `${FAVORITE_LIBRARY_VIDEO}_SUCCESS`) {
    nextState = nextState.update('data', data => data.push(Immutable.fromJS(action.json)));
  }

  if (action.type === `${UNFAVORITE_LIBRARY_VIDEO}_SUCCESS`) {
    nextState = nextState.update('data', data =>
      data.filter(record => record.get('library_video_id') !== action.json.library_video_id)
    );
  }

  if (action.type === `${UNFAVORITE_EPISODE_VIDEO}_SUCCESS`) {
    if (nextState.get('data')) {
      nextState = nextState.update('data', data =>
        data.filter(record => record.get('tv_episode_id') !== action.json.tv_episode_id)
      );
    }
  }

  return nextState;
};

const favoritingLibraryApiReducer = getApiReducer(FAVORITE_LIBRARY_VIDEO);
const favoritingLibrary = (state, action) => {
  let nextState = favoritingLibraryApiReducer(state, action);

  switch (action.type) {
    case `${FAVORITE_LIBRARY_VIDEO}_REQUEST`:
      return nextState.set('videoId', action.libraryVideoId);
    case `${FAVORITE_LIBRARY_VIDEO}_SUCCESS`:
      return nextState.set('videoId', null);
    default:
      return nextState;
  }
};
const unfavoritingLibraryApiReducer = getApiReducer(UNFAVORITE_LIBRARY_VIDEO);
const unfavoritingLibrary = (state, action) => {
  let nextState = unfavoritingLibraryApiReducer(state, action);

  if (action.type === `${UNFAVORITE_LIBRARY_VIDEO}_REQUEST`) {
    nextState = nextState.set('videoId', action.libraryVideoId);
  }

  return nextState;
};

const favoritingEpisodeApiReducer = getApiReducer(FAVORITE_EPISODE_VIDEO);
const favoritingEpisode = (state, action) => {
  let nextState = favoritingEpisodeApiReducer(state, action);

  switch (action.type) {
    case `${FAVORITE_EPISODE_VIDEO}_REQUEST`:
      return nextState.set('episodeId', action.episodeId);
    case `${FAVORITE_EPISODE_VIDEO}_SUCCESS`:
      return nextState.set('episodeId', null);
    default:
      return nextState;
  }
};

const unfavoritingEpisodeApiReducer = getApiReducer(UNFAVORITE_EPISODE_VIDEO);
const unfavoritingEpisode = (state, action) => {
  let nextState = unfavoritingEpisodeApiReducer(state, action);

  if (action.type === `${UNFAVORITE_EPISODE_VIDEO}_REQUEST`) {
    nextState = nextState.set('episodeId', action.episodeId);
  }

  return nextState;
};

export default combineReducers({
  favorites,
  favoritingLibrary,
  unfavoritingLibrary,
  favoritingEpisode,
  unfavoritingEpisode,
});



// WEBPACK FOOTER //
// ./src/subscription/library/favorites/redux/reducers.js